<template>
  <fa-icon class="spinner" icon="fa-circle-notch" size="xl" spin style="--fa-animation-duration: 1s" />
</template>

<style lang="scss" scoped>
.spinner {
  color: $color-base-c2c;
}
</style>
